export default "__VITE_ASSET__K6hNYgQq__"